const list = [{
		name: '权限管理',
		menuItem: {
			name: '权限管理',
			iconClass: 'dk-icon-home',
			route: '/admin-list',
		}
	},
	{
		name: '管理员列表',
		menuItem: {
			name: '管理员列表',
			route: '/admin-list',
		}
	},
	{
		name: '身份管理',
		menuItem: {
			name: '身份管理',
			route: '/role-manage',
		}
	},
	{
		name: '用户管理',
		menuItem: {
			name: '用户管理',
			iconClass: 'dk-icon-home',
			route: '/user-list',
		}
	},
	{
		name: '用户列表',
		menuItem: {
			name: '用户列表',
			route: '/user-list',
		}
	},
	{
		name: '用户详情',
		menuItem: {
			name: '用户详情',
			iconClass: 'dk-icon-home',
			route: '/user-list/user-detail',
		}
	},
	{
		name: '业务管理',
		menuItem: {
			name: '业务管理',
			iconClass: 'dk-icon-home',
			route: '/salesman-list',
		}
	},
	{
		name: '业务员列表',
		menuItem: {
			name: '业务员列表',
			route: '/salesman-list',
		}
	},
	{
		name: '业务员详情',
		menuItem: {
			name: '业务员详情',
			route: '/salesman-list/salesman-detail',
		}
	},
	{
		name: '订单管理',
		menuItem: {
			name: '订单管理',
			iconClass: 'dk-icon-home',
			route: '/order-list',
		}
	},
	{
		name: '订单列表',
		menuItem: {
			name: '订单列表',
			route: '/order-list',
		}
	},
	{
		name: '订单详情',
		menuItem: {
			name: '订单详情',
			route: '/order-list/order-detail',
		}
	},
	{
		name: '新建订单',
		menuItem: {
			name: '新建订单',
			route: '/order-list/add-order',
		}
	},
	{
		name: '服务管理',
		menuItem: {
			name: '服务管理',
			iconClass: 'dk-icon-home',
			route: '/service-project-manage',
		}
	},
	{
		name: '服务项目管理',
		menuItem: {
			name: '服务项目管理',
			route: '/service-project-manage',
		}
	},
	{
		name: '佣金比例设置',
		menuItem: {
			name: '佣金比例设置',
			route: '/commission-rate',
		}
	},
	{
		name: '内容管理',
		menuItem: {
			name: '内容管理',
			iconClass: 'dk-icon-home',
			route: '/message-push',
		}
	},
	{
		name: '系统消息推送',
		menuItem: {
			name: '系统消息推送',
			route: '/message-push',
		}
	},
	{
		name: '轮播图管理',
		menuItem: {
			name: '轮播图管理',
			route: '/slideimg-manage',
		}
	},
	{
		name: '评论管理',
		menuItem: {
			name: '评论管理',
			route: '/comment-manage',
		}
	},
	{
		name: '充值管理',
		menuItem: {
			name: '充值管理',
			iconClass: 'dk-icon-home',
			route: '/recharge-list',
		}
	},
	{
		name: '充值列表',
		menuItem: {
			name: '充值列表',
			route: '/recharge-list',
		}
	},
	{
		name: '充值记录',
		menuItem: {
			name: '充值记录',
			route: '/recharge-records',
		}
	},
	{
		name: '财务管理',
		menuItem: {
			name: '财务管理',
			iconClass: 'dk-icon-home',
			route: '/withdraw-manage',
		}
	},
	{
		name: '提现管理',
		menuItem: {
			name: '提现管理',
			route: '/withdraw-manage',
		}
	},
	{
		name: '平台流水',
		menuItem: {
			name: '平台流水',
			route: '/platform-flow',
		}
	},
	{
		name: 'VIP设置',
		menuItem: {
			name: 'VIP管理',
			route: '/member-list',
			iconClass: 'dk-icon-home',
		}
	},
	{
		name: 'VIP列表',
		menuItem: {
			name: 'VIP列表',
			route: '/member-list',
		}
	},
	{
		name: '购买记录',
		menuItem: {
			name: '购买记录',
			route: '/purchase-record',
		}
	},
	{
		name: '会员设置',
		menuItem: {
			name: 'VIP设置',
			route: '/member-setting',
		}
	},
	
	
	{
		name: '标签管理',
		menuItem: {
			name: '标签管理',
			route: '/follow-tag',
			iconClass: 'dk-icon-home',
		}
	},
	{
		name: '进度标签设置',
		menuItem: {
			name: '进度标签设置',
			route: '/follow-tag',
		}
	},
	{
		name: '快捷输入标签设置',
		menuItem: {
			name: '快捷输入标签设置',
			route: '/quick-input-tag',
		}
	},
	{
		name: '撤回标签设置',
		menuItem: {
			name: '撤回标签设置',
			route: '/cancel-input-tag',
		}
	},
]
const mapper = new Map()
list.forEach((value) => {
	mapper.set(value.name, value.menuItem)
})

export default mapper
